var _templateObject;
var _excluded = ["homepassModalOpen", "closeHomepassModal", "onBookInspectionClick", "submitHomepassBooking"];
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import gql from 'graphql-tag';
import { variables } from '@domain-group/fe-brary';
import { ToggledFeatureKey } from '@domain-group/fe-allhomes-library';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { Modal } from '@domain-group/fe-blueprint-ui/modal';
import HomepassBooking from '@domain-group/fe-co-homepass-booking';
import { EventBoundary, withEventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import AllhomesBreadcrumbs from '@domain-group/fe-co-allhomes-breadcrumbs';
import { ListingEnquiryFormGraphQL, MobileEnquiryCTAGraphQL } from '@domain-group/fe-co-allhomes-enquiry-form';
import { AllhomesNonEuUser } from '@domain-group/fe-co-allhomes-eu-user';
import { AllhomesKeyDetailsGraphQL } from '@domain-group/fe-co-allhomes-key-details';
import { AllhomesListingMapGraphQL } from '@domain-group/fe-co-allhomes-listing-map';
import { AllhomesListingMoreListingsGraphQL } from '@domain-group/fe-co-allhomes-listing-more-listings';
import AllhomesListingPhotoCarousel from '@domain-group/fe-co-allhomes-listing-photo-carousel';
import { AllhomesListingSuburbStatsGraphQL } from '@domain-group/fe-co-allhomes-listing-suburb-stats';
import { AllhomesListingSummaryGraphQL } from '@domain-group/fe-co-allhomes-listing-summary';
import { PropertyHistoryGraphQL } from '@domain-group/fe-co-allhomes-property-history';
import { BtrInfoMessage } from '@domain-group/fe-co-allhomes-shared-components';
import StickyMobile from '@domain-group/fe-co-allhomes-sticky-footer';
import AllhomesWatchlistButton from '@domain-group/fe-co-allhomes-watchlist-button';
import ListingAvailabilityGraphQL from '../components/availability/listing-availability-graphql';
import { ListingViewsGraphQL } from '../components/listing-views';
import StickySidebox from '../components/sticky-sidebox';
import DocumentsGraphQL from '../components/documents/documents-graphql';
import OnMarketSidebox from '../components/on-market-sidebox';
import FlagAsInappropriateLink from '../components/flag-as-inappropriate-link';
import { InspectionsAuctionsGraphQL } from '../components/inspections-auctions';
import ListingPhotoPreview from '../components/allhomes-listing-hero-photo-preview';
import { Inner, InnerLeft, InnerRight, Section, HeroImages, Clear, Bottom } from '../components/structure';
import NextEventGraphQL from '../components/next-event/next-event-graphql';
import { FeaturedArticle } from '../components/editorial';
import AllhomesListingWhatsNearbyGraphQL from '../components/what-is-nearby/allhomes-listing-whats-nearby-graphql';
import { NbnCardGraphQL } from '../components/nbn-card';
import { NewDevelopmentChildDetailsGraphQL } from '../components/new-development-child-details';
import { onMarketPropertyWrapper } from '../wrappers';
import ListingDetailsCommonProps, { ListingDetailsDefaultValues } from '../props/common-props';
import { scrollToEnquiryForm } from '../utils/scrolling';
import useHomepass from '../utils/homepass';
import useBackToSearch from '../utils/back-to-search';
import useSendPageView from '../analytics/use-send-page-view';
import { AgencyBrandingHeader, getSideboxTopEdgeOffset } from '../components/agency-branding-header';
import * as sharedStyles from './on-market.style';
import * as styles from './on-market-rental.style';
import { FeaturesGraphQL } from '../components/features';
import { PropertyWalkthrough } from '../components/property-walkthrough/property-walkthrough';
import { jsx as ___EmotionJSX } from "@emotion/core";
var BaseOnMarketRentalListingDetails = props => {
  var _property$agents, _property$agents$, _property$agents2, _property$development, _property$listing$med, _property$listing$med2, _property$agents$2, _agent$inclusions, _agency$images, _property$listing, _property$listing$med3, _property$listing2, _property$listing3, _property$listing$med4, _property$listing$med5, _property$agents$3;
  useSendPageView();
  var _useAllhomesApi = useAllhomesApi(),
    toggledFeatures = _useAllhomesApi.toggledFeatures;
  var sidebarBottomRef = useRef();
  var enquiryFormStart = useRef();
  var _useHomepass = useHomepass(props),
    homepassModalOpen = _useHomepass.homepassModalOpen,
    closeHomepassModal = _useHomepass.closeHomepassModal,
    onBookHomepassInspectionClick = _useHomepass.onBookInspectionClick,
    submitHomepassBooking = _useHomepass.submitHomepassBooking,
    homepassProps = _objectWithoutProperties(_useHomepass, _excluded);
  var property = props.property;
  var _props$media = props.media,
    mobile = _props$media.mobile,
    tablet = _props$media.tablet,
    desktop = _props$media.desktop;
  var backToSearch = useBackToSearch(props.referrer);
  var hasPrivateLister = (_property$agents = property.agents) === null || _property$agents === void 0 ? void 0 : (_property$agents$ = _property$agents[0]) === null || _property$agents$ === void 0 ? void 0 : _property$agents$.isPrivateLister;
  var hasAgents = ((_property$agents2 = property.agents) === null || _property$agents2 === void 0 ? void 0 : _property$agents2.length) > 0;
  var isBTR = (property === null || property === void 0 ? void 0 : (_property$development = property.development) === null || _property$development === void 0 ? void 0 : _property$development.type) === 'RENTAL';
  var hasWalkthroughs = !!(property !== null && property !== void 0 && (_property$listing$med = property.listing.media.virtualTour[0]) !== null && _property$listing$med !== void 0 && _property$listing$med.imageSrc || property !== null && property !== void 0 && (_property$listing$med2 = property.listing.media.video[0]) !== null && _property$listing$med2 !== void 0 && _property$listing$med2.imageSrc);
  var agent = property === null || property === void 0 ? void 0 : property.agents[0];
  var agency = property === null || property === void 0 ? void 0 : (_property$agents$2 = property.agents[0]) === null || _property$agents$2 === void 0 ? void 0 : _property$agents$2.agency;
  var isPlatinum = (agent === null || agent === void 0 ? void 0 : (_agent$inclusions = agent.inclusions) === null || _agent$inclusions === void 0 ? void 0 : _agent$inclusions.brandingLevel) === 'PLATINUM';
  var showAgencyBrandingHeader = isPlatinum && toggledFeatures[ToggledFeatureKey.AGENCY_BRANDING] && (agency === null || agency === void 0 ? void 0 : (_agency$images = agency.images) === null || _agency$images === void 0 ? void 0 : _agency$images.tinyLogo);
  var handleEmailClick = (clickedAgency, clickedAgent) => {
    scrollToEnquiryForm({
      agency: clickedAgency,
      agent: clickedAgent
    });
  };
  return ___EmotionJSX("div", null, !mobile && showAgencyBrandingHeader && ___EmotionJSX(AgencyBrandingHeader, {
    agency: agency
  }), mobile && hasAgents && ___EmotionJSX(StickyMobile, {
    limitRef: enquiryFormStart
  }, ___EmotionJSX(MobileEnquiryCTAGraphQL, {
    property: property,
    onEmailClick: () => handleEmailClick(property.agencies[0]),
    applyOnlineLink: props.applyOnlineLink
  })), mobile && ___EmotionJSX(AllhomesBreadcrumbs, {
    css: sharedStyles.breadcrumbs,
    items: props.breadcrumbs,
    goBackText: backToSearch.text,
    goBackUrl: backToSearch.link
  }), mobile && showAgencyBrandingHeader && ___EmotionJSX(AgencyBrandingHeader, {
    agency: agency
  }), ___EmotionJSX(HeroImages, null, ___EmotionJSX(ListingPhotoPreview, props), props.carouselOpen && !isEmpty((_property$listing = property.listing) === null || _property$listing === void 0 ? void 0 : (_property$listing$med3 = _property$listing.media) === null || _property$listing$med3 === void 0 ? void 0 : _property$listing$med3.items) && ___EmotionJSX(EventBoundary, {
    name: "listing"
  }, ___EmotionJSX(AllhomesListingPhotoCarousel, {
    fullscreenOnOpen: mobile,
    items: props.items,
    initialIndex: props.initialIndex,
    onSlideChange: props.onSlideChange,
    onSlideClick: props.onSlideClick,
    onSlideLeft: props.onSlideLeft,
    onSlideRight: props.onSlideRight,
    onClose: props.onClose
  })), props.historyGalleryOpen && ___EmotionJSX(EventBoundary, {
    name: "history"
  }, ___EmotionJSX(AllhomesListingPhotoCarousel, _extends({}, props.historyGalleryProps, {
    fullscreenOnOpen: mobile,
    onSlideChange: props.onPropertyHistoryGalleryChange,
    onSlideLeft: props.onPropertyHistoryGalleryLeft,
    onSlideRight: props.onPropertyHistoryGalleryRight,
    onSlideClick: props.onPropertyHistoryGalleryClick
  }))), (mobile || tablet) && ___EmotionJSX("div", {
    css: sharedStyles.watchlistButton
  }, ___EmotionJSX(AllhomesWatchlistButton, {
    listingId: parseInt(property.listing.id, 10),
    onAddToWatchlist: props.onAddToWatchlist,
    popupAlignment: "right",
    inactiveColour: variables.colour.white,
    activeColour: variables.colour.brandYellow
  }))), mobile && ___EmotionJSX("div", null, ___EmotionJSX(NextEventGraphQL, {
    property: property
  })), ___EmotionJSX(Inner, null, tablet && ___EmotionJSX(AllhomesBreadcrumbs, {
    css: sharedStyles.breadcrumbs,
    items: props.breadcrumbs,
    goBackText: backToSearch.text,
    goBackUrl: backToSearch.link
  }), ___EmotionJSX(InnerLeft, null, desktop && ___EmotionJSX(AllhomesBreadcrumbs, {
    css: sharedStyles.breadcrumbs,
    items: props.breadcrumbs,
    goBackText: backToSearch.text,
    goBackUrl: backToSearch.link
  }), ___EmotionJSX(AllhomesListingSummaryGraphQL, {
    preDescription: isBTR && ___EmotionJSX(BtrInfoMessage, {
      variant: "listing"
    }),
    property: property,
    onAddToWatchlist: props.onAddToWatchlist,
    onResizeFinished: () => window.dispatchEvent(new Event('resize')),
    onLogoClicked: handleEmailClick,
    clientRenderedDescription: props.clientRenderedDescription
  }, !isBTR && ___EmotionJSX(NbnCardGraphQL, {
    property: property
  })), ___EmotionJSX(FeaturedArticle, {
    article: property.listing.featuredArticle
  }), (property.listing.availableNow || property.listing.availableFrom) && ___EmotionJSX("div", {
    css: styles.availability
  }, ___EmotionJSX(ListingAvailabilityGraphQL, {
    property: property
  })), ___EmotionJSX(Section, null, ___EmotionJSX(InspectionsAuctionsGraphQL, {
    property: property,
    onRemoveFromPlanner: props.onRemoveFromPlannerClick,
    onSignUpClick: props.onSignUpClick,
    onSignInClick: props.onSignInClick,
    onBookHomepassInspectionClick: onBookHomepassInspectionClick,
    onContactAgentClick: handleEmailClick,
    onVideoClick: props.onClickVideo,
    onVirtualTourClick: props.onClickVirtualTour,
    disableWalkthroughs: isBTR
  })), isBTR && (!isEmpty(property === null || property === void 0 ? void 0 : (_property$listing2 = property.listing) === null || _property$listing2 === void 0 ? void 0 : _property$listing2.primaryFeatures) || !isEmpty(property === null || property === void 0 ? void 0 : (_property$listing3 = property.listing) === null || _property$listing3 === void 0 ? void 0 : _property$listing3.secondaryFeatures)) && ___EmotionJSX(Section, null, ___EmotionJSX(FeaturesGraphQL, {
    property: property
  })), !isEmpty(property.listing.documents) && ___EmotionJSX(Section, null, ___EmotionJSX(DocumentsGraphQL, {
    property: property
  })), desktop && isBTR && ___EmotionJSX(Section, null, ___EmotionJSX(NewDevelopmentChildDetailsGraphQL, {
    property: property,
    onChildDevelopmentLinkClick: props.onChildDevelopmentLinkClick
  })), isBTR && hasWalkthroughs && ___EmotionJSX(Section, null, ___EmotionJSX(PropertyWalkthrough, {
    virtualTour: property === null || property === void 0 ? void 0 : (_property$listing$med4 = property.listing.media.virtualTour[0]) === null || _property$listing$med4 === void 0 ? void 0 : _property$listing$med4.imageSrc,
    onVirtualTourClick: props.onClickVirtualTour,
    video: property === null || property === void 0 ? void 0 : (_property$listing$med5 = property.listing.media.video[0]) === null || _property$listing$med5 === void 0 ? void 0 : _property$listing$med5.imageSrc,
    onVideoClick: props.onClickVideo
  })), (tablet || desktop) && ___EmotionJSX(Section, null, ___EmotionJSX(AllhomesKeyDetailsGraphQL, {
    property: property
  })), ___EmotionJSX("div", {
    ref: sidebarBottomRef
  })), (tablet || desktop) && ___EmotionJSX(InnerRight, null, ___EmotionJSX(StickySidebox, {
    sidebarBottom: sidebarBottomRef,
    topEdgeOffset: getSideboxTopEdgeOffset({
      showAgencyBrandingHeader,
      desktop
    })
  }, ___EmotionJSX(OnMarketSidebox, _extends({}, props, {
    property: property,
    onEmailClick: handleEmailClick
  })))), ___EmotionJSX(Clear, null), tablet && isBTR && ___EmotionJSX(Section, {
    fullWidth: true
  }, ___EmotionJSX(NewDevelopmentChildDetailsGraphQL, {
    property: property,
    onChildDevelopmentLinkClick: props.onChildDevelopmentLinkClick
  })), !isEmpty(property.address.coordinates) && ___EmotionJSX(Section, {
    fullWidth: true
  }, ___EmotionJSX(Clear, null), ___EmotionJSX(AllhomesListingMapGraphQL, _extends({
    property: property,
    onTabSelect: props.onMapTypeSelect,
    onOverlaySelect: props.onMapOverlaySelect,
    onMapFirstInteraction: props.onMapFirstInteraction
  }, props))), mobile && isBTR && ___EmotionJSX(Section, null, ___EmotionJSX(NewDevelopmentChildDetailsGraphQL, {
    property: property,
    onChildDevelopmentLinkClick: props.onChildDevelopmentLinkClick
  })), mobile && ___EmotionJSX(Section, null, ___EmotionJSX(AllhomesKeyDetailsGraphQL, {
    property: property
  })), mobile && ___EmotionJSX(Section, null, ___EmotionJSX(AllhomesListingSuburbStatsGraphQL, {
    property: property,
    onSuburbInfoClick: props.onSuburbInfoClick,
    onSummaryTabClick: props.onSummaryTabClick,
    onMedianSalesTabClick: props.onMedianSalesTabClick,
    onViewMoreInfoClick: props.onViewMoreInfoClick,
    onUVClick: props.onUVClick,
    disableAnimation: props.disableAnimation,
    layout: "mobile"
  })), !isEmpty(property.address.nearbyPOIs) && ___EmotionJSX(Section, {
    fullWidth: true,
    borderless: mobile
  }, ___EmotionJSX(AllhomesListingWhatsNearbyGraphQL, {
    property: property,
    columns: desktop ? 3 : 2
  })), ___EmotionJSX(Bottom, null, ___EmotionJSX(Section, {
    fullWidth: true
  }, ___EmotionJSX("div", {
    css: styles.propertyHistory
  }, ___EmotionJSX(PropertyHistoryGraphQL, {
    property: property,
    onPhotoClick: props.openHistoryGallery,
    onSwipeLeft: props.onPropertyHistorySwipeLeft,
    onSwipeRight: props.onPropertyHistorySwipeRight,
    onTapLeftChevron: props.onPropertyHistoryTapLeft,
    onTapRightChevron: props.onPropertyHistoryTapRight,
    onExpand: props.onPropertyHistoryExpand,
    onCollapse: props.onPropertyHistoryCollapse,
    isOnMarket: true
  }))), (tablet || desktop) && ___EmotionJSX(Section, {
    fullWidth: true
  }, ___EmotionJSX(AllhomesListingSuburbStatsGraphQL, {
    property: property,
    onSuburbInfoClick: props.onSuburbInfoClick,
    onSummaryTabClick: props.onSummaryTabClick,
    onMedianSalesTabClick: props.onMedianSalesTabClick,
    onViewMoreInfoClick: props.onViewMoreInfoClick,
    onUVClick: props.onUVClick,
    disableAnimation: props.disableAnimation,
    layout: "tabbed"
  })), ___EmotionJSX("div", {
    ref: enquiryFormStart
  }), ___EmotionJSX(ListingEnquiryFormGraphQL, _extends({
    property: property,
    sponsorship: props.sponsorship
  }, props.enquiryFormProps)), !isEmpty((_property$agents$3 = property.agents[0]) === null || _property$agents$3 === void 0 ? void 0 : _property$agents$3.listings.listings) && ___EmotionJSX("div", {
    css: sharedStyles.moreListingsContainer
  }, ___EmotionJSX(AllhomesListingMoreListingsGraphQL, {
    property: property
  })), hasPrivateLister && props.flagAsInappropriateLink && ___EmotionJSX(AllhomesNonEuUser, null, ___EmotionJSX(FlagAsInappropriateLink, {
    href: props.flagAsInappropriateLink
  })))), ___EmotionJSX(ListingViewsGraphQL, {
    property: property
  }), homepassModalOpen && ___EmotionJSX(Modal, {
    closeCallback: closeHomepassModal,
    idealWidth: desktop || tablet ? 500 : 440,
    minimal: false
  }, ___EmotionJSX(HomepassBooking, _extends({}, homepassProps, {
    onCloseModalCallback: closeHomepassModal,
    onSubmit: submitHomepassBooking,
    isV2APIs: true
  }))));
};
BaseOnMarketRentalListingDetails.propTypes = _objectSpread(_objectSpread({}, ListingDetailsCommonProps), {}, {
  onInspectFromHomeClick: PropTypes.func
});
BaseOnMarketRentalListingDetails.defaultProps = _objectSpread(_objectSpread({}, ListingDetailsDefaultValues), {}, {
  onInspectFromHomeClick: () => {}
});
BaseOnMarketRentalListingDetails.fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment OnMarketRentalListingDetails on Property {\n    agents {\n      type\n      isPrivateLister\n    }\n  }\n"])));
export default onMarketPropertyWrapper(withEventBoundary('rental')(BaseOnMarketRentalListingDetails));
export { BaseOnMarketRentalListingDetails };